export const categories = [
  {
    id: 'yule-bagua',
    name: '娱乐八卦',
    slug: 'yule-bagua',
    description: '娱乐圈最新八卦动态，明星绯闻、恋情曝光、分手内幕等劲爆消息',
    color: 'bg-primary-500',
    articleCount: 128,
  },
  {
    id: 'wangluo-redian',
    name: '网络热点',
    slug: 'wangluo-redian',
    description: '全网最热话题追踪，微博热搜、抖音热榜、小红书爆款一网打尽',
    color: 'bg-accent-500',
    articleCount: 96,
  },
  {
    id: 'dujia-mengliao',
    name: '独家猛料',
    slug: 'dujia-mengliao',
    description: '51扒瓜网独家爆料，第一手猛料直击，让瓜友们永远走在吃瓜最前线',
    color: 'bg-secondary-500',
    articleCount: 64,
  },
  {
    id: 'mingxing-dongtai',
    name: '明星动态',
    slug: 'mingxing-dongtai',
    description: '明星最新行程、活动路透、时尚穿搭、影视作品等全方位追踪报道',
    color: 'bg-primary-600',
    articleCount: 156,
  },
];

export const hotTags = [
  '顶流恋情',
  '离婚内幕',
  '综艺爆料',
  '片场事故',
  '代言风波',
  '税务问题',
  '整容实锤',
  '代孕疑云',
  '家暴实锤',
  '学历造假',
  '商业互撕',
  '粉丝互骂',
  '出轨证据',
  '私生子传闻',
  '复合迹象',
];